import { GlobalService } from 'src/app/global.service';
import { DomSanitizer } from '@angular/platform-browser';
import { Component, OnInit } from '@angular/core';
import { HttpService } from 'src/app/http.service';
import { ThemePalette, ProgressSpinnerMode } from '@angular/material';

@Component({
  selector: 'app-date-wise-tray-count',
  templateUrl: './date-wise-tray-count.component.html',
  styleUrls: ['./date-wise-tray-count.component.scss']
})
export class DateWiseTrayCountComponent implements OnInit {

  session_list = [{'name': 'Morning', 'value': 1}, {'name': 'Evening', 'value': 2}, {'name': 'Both', 'value': 'both'}];
  route_list = [{'name': 'Route', 'value': 'route'}, {'name': 'Temp Route', 'value': 'temp'}, {'name': 'Both', 'value': 'both'}];
  selected_session : any;
  selected_route : any;
  pdf_data: any;
  selected_frm_date : Date;
  selected_to_date : Date;
  is_document_available: boolean = true;
  document_file: any = null;
  color: ThemePalette = 'primary';
  mode: ProgressSpinnerMode = 'indeterminate';
  title: any;

  constructor(private httpService: HttpService, private dom: DomSanitizer) { }

  getClicked() {
    this.document_file = null;
    let data_dict = {
      'selected_from_date': this.selected_frm_date,
      'selected_to_date' : this.selected_to_date,
      'selected_session_id': this.selected_session,
      'route': this.selected_route
    };
    console.log(data_dict);
    this.is_document_available = false;
    this.httpService.serveDayWiseTrayTotalCount(data_dict).subscribe((data) => {
      console.log(data);
      this.pdf_data = this.dom.bypassSecurityTrustResourceUrl('data:application/pdf;base64,' + data['pdf']);
      this.document_file = data;
      this.is_document_available = true;
    }, (error) => {
      this.is_document_available = true;
    });
  }

  downloadClicked() {
    const linkSource = 'data:application/pdf;base64,' + this.document_file['pdf'];
    const downloadLink = document.createElement("a");
    const fileName = this.document_file['file_name'];
    downloadLink.href = linkSource;
    downloadLink.download = fileName;
    downloadLink.click();
  }

  ngOnInit() {
  }

  changeEvent() {
    this.document_file = null;
  }

}
